export default __webpack_public_path__ + "static/media/playlist-decorator-related.123bafac.svg";